import React from "react";

const Select = React.forwardRef(function Select(
    { className = "", id, label, children, ...rest },
    ref,
) {
    return (
        <div className="w-full">
            {label && (
                <label htmlFor={id} className="mb-1.5 block text-sm font-medium text-ink-700">
                    {label}
                </label>
            )}
            <div className="relative">
                <select
                    ref={ref}
                    id={id}
                    className={`block w-full appearance-none rounded-lg border border-ink-200 bg-white py-2 pl-3 pr-9 text-sm text-ink-900 transition-colors hover:border-ink-300 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-400 ${className}`}
                    {...rest}
                >
                    {children}
                </select>
                <span
                    className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-ink-400"
                    aria-hidden="true"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <polyline points="6 9 12 15 18 9" />
                    </svg>
                </span>
            </div>
        </div>
    );
});

export default Select;
